import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router';

import { useCurrentUser } from './session';
import { FullPageSpinner } from '../../components/FullPageSpinner';

export function RequireAuth({ children }: { children: ReactNode }) {
  const location = useLocation();
  const { data: user, isPending, isError } = useCurrentUser();

  if (isPending) return <FullPageSpinner />;
  if (isError || !user) return <Navigate to="/login" replace state={{ from: location.pathname }} />;

  return <>{children}</>;
}
